import React from 'react';
import { API_URL } from 'constants/config';
import { header } from 'constants/table';
import DataTable from 'components/data-table';
import { RowItemDanhSachKeHoachThanhTraDaPheDuyet } from 'modules/thanh-tra/datatable';
import { DatePicker, Input, DropDown } from 'components/tt-forms/common';
import { ThanhTra, Danhmuc } from 'api';
import { Toastr } from 'modules/toastr';
import classnames from 'classnames';
import { msg } from "constants/message";
import { connect } from 'react-redux';
import moment from 'moment';
import {downloadFile} from "constants/downloadFile";
import { isEmpty } from 'lodash';

class DanhSachKeHoachThanhTraDaPheDuyet extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      tuNgay: '',
      denNgay: '',
      soQuyetDinh: '',
      namThanhTra: '',
      nguoiKy: '',
      donViIds: [],
      donViChuTriList: [],
      donViSelected: [],
      loading: false,
      thanhTraQuanHuyenId: ''
    }
  }

  componentDidMount() {
    let state = this.state;
    let data = localStorage.getItem('khttData') ? JSON.parse(localStorage.getItem('khttData')) : {};
    this.getDonViChuTri(data.donViSelected);
    state.pageData.number = data.page || 0;
    state.pageData.size = data.size || 10;
    state.soQuyetDinh = data.soQuyetDinh || '';
    state.nguoiKy = data.nguoiKy || '';
    state.namThanhTra = this.props.goBack ? data.namThanhTra : '';
    state.donViSelected = data.donViSelected || [];
    state.tuNgay = '';
    state.denNgay = '';
    this.getKeHoachThanhTraList();
    this.checkDonVi();
    this.getNamThanhTraList();
    this.checkDonViQuanHuyen();
    this.setState(state);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.namThanhTra !== prevProps.namThanhTra) {
      this.forceUpdate();
    }
  }

  checkDonVi() {
    Danhmuc.actions.getThamSo.request(null, {tuKhoa: 'CQQL_THANH_TRA_THANH_PHO'}).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({thanhTraThanhPhoId: res.data._embedded.thamSoes.length ? res.data._embedded.thamSoes[0].giaTri : ''});
      }
    });
  }

  checkDonViQuanHuyen() {
    Danhmuc.actions.getThamSo.request(null, {tuKhoa: 'CCQQL_UBND_QUAN_HUYEN'}).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({thanhTraQuanHuyenId: res.data._embedded.thamSoes.length ? res.data._embedded.thamSoes[0].giaTri : ''});
      }
    });
  }

  getDonViChuTri(selectedItem) {
    ThanhTra.actions.getDonViKHTT.request().then(res => {
      if (!this.refs.dskhtt) {
        return;
      }
      let donViChuTriList = [];
      let donViSelected = [];
      if (res.data && res.data._embedded) {
        donViChuTriList = res.data._embedded.coQuanQuanLies;
        donViSelected = selectedItem || [];
      } else {
        donViChuTriList = [];
      }
      this.setState({donViChuTriList,donViSelected});
    });
  }

  checkDate(stD, endD) {
    let startDate = moment(stD, 'MM/DD/YYYY').valueOf();
    let endDate = moment(endD, 'MM/DD/YYYY').valueOf();
    if (startDate > endDate) {
      Toastr('Từ ngày phải nhỏ hơn Đến ngày', 'warning');
    }
  }

  async getKeHoachThanhTraList(isFirst, e) {
    let state = this.state;
    if (typeof e !== 'undefined') {
      e.preventDefault();
    }
    if (this.validateSubmitForm()) {
      if (isFirst) {
        state.pageData = {
          number: 0,
          size: 10,
          totalElements: 0
        };
      }
      let params = {
        page: state.pageData.number,
        size: state.pageData.size,
        sort: 'namThanhTra,desc',
        isTatCaDonVi: false,
        isPheDuyet: true
      }
      if (state.donViSelected.length) {
        let idArr = [];
        state.donViSelected.map(item => {
          idArr.push(item.value);
        });
        params.donViIds = idArr.join();
      }
      if (state.soQuyetDinh) {
        params.soQuyetDinh = state.soQuyetDinh;
      }
      if (state.tuNgay) {
        params.tuNgay = moment(state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      if (state.denNgay) {
        params.denNgay = moment(state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      if (state.tuNgay && state.denNgay && isFirst === true) {
        this.checkDate(state.tuNgay, state.denNgay);
      }
      if (state.nguoiKy) {
        params.nguoiKy = state.nguoiKy;
      }
      if (!isEmpty(state.namThanhTra)) {
        params.namThanhTra = state.namThanhTra;
      }
      state.loading = true;
      await this.setState({loading: true});
      await localStorage.setItem('khttData', JSON.stringify({...params, donViSelected: state.donViSelected}));
      await ThanhTra.actions.getKeHoachThanhTra.request(null, params).then(res => {
        if (!this.refs.dskhtt) {
          return;
        }
        if (res.data._embedded) {
          state = {
            ...state,
            data: res.data._embedded.medial_KeHoachThanhTra_DanhSaches,
            pageData: res.data.page,
            tableLoading: false,
            loading: false
          };
        } else {
          state = {
            ...state,
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false,
            loading: false
          };
        }
      });
    }
    this.setState(state);
    this.props.dispatch({type:'DSTT_RESET_GO_BACK'});
  }

  onChange(name, e) {
    if (name == 'DonVi') {
      this.setState({
        donViSelected: e
      });
    } else {
      this.setState({
        [name]: e.target.value
      });
    }
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getKeHoachThanhTraList();
  }

  handleChangePageSize(size) {
    let state = this.state;
    state.pageData.size = size;
    state.pageData.number = 0;
    this.getKeHoachThanhTraList();
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if (pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  handleDelete(sID) {
    ThanhTra.actions.deleteKeHoachThanhTra.request({id: sID}).then(res => {
      Toastr(msg.removeKHSuccess, 'success');
      this.getKeHoachThanhTraList();
    });
  }

  getNamThanhTraList() {
    if (this.props.namThanhTra.length === 0) {
      ThanhTra.actions.getNamThanhTra.request().then(res => {
        if (res && res.data) {
          this.props.dispatch({type:'SET_NAM_THANH_TRA', data: res.data});
        }
      });
    }
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  handleExport() {
    // if (this.state.donViSelected.length) {
      // let idArr = [];
      const donViSelected = this.state.donViSelected || [];
      const idArr = donViSelected.map(item => item.value);
      const donViIds = idArr.join();
      let URL = String(API_URL) + "/danhMucCuocThanhTras/xuatExcel?soQuyetDinh=" + this.state.soQuyetDinh
      + "&tuNgay=" + (this.state.tuNgay ? moment(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '')
      + "&denNgay=" + (this.state.denNgay ? moment(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '')
      + "&namThanhTra=" + (this.state.namThanhTra ? this.state.namThanhTra : '')
      + "&nguoiKy=" + (this.state.nguoiKy ? this.state.nguoiKy : '')
      + "&donViIds=" + (donViIds ? this.state.donViIds : []);

      downloadFile(URL);
    // }
  }

  render() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    return (
      <div className="center reception-container" ref="dskhtt">
        <div className="top-content">
          <div className="left-content">
            <p className="title-18"><i className="tt tt-thanh-tra"></i>Danh sách kế hoạch thanh tra, kiểm tra đã phê duyệt</p>
          </div>
          {/* <div className="right-content">
            { CheckPermission('THANHTRA_THEM') &&
              <Link className="btn-green" to='/thanh-tra/them-moi-ke-hoach'><si className="tt tt-addfile"></i>Thêm mới</Link>
            }
          </div> */}
        </div>
        <div className="bottom-content">
          <div className='wrap-block pl15 pr15 pt20'>
            <form onSubmit={this.getKeHoachThanhTraList.bind(this, true)}>
              <div className='row pl10 pr10'>
                <div className='col-83 no-gutter'>
                  <Input className='col-25' label="Số quyết định phê duyệt KHTT/KHKT" placeholder="Nhập số quyết định" value={this.state.soQuyetDinh} onChange={this.onChange.bind(this, 'soQuyetDinh')} name='soQuyetDinh' maxLength={255}/>
                  <DatePicker className="col-20" label="Quyết định ra từ ngày" bindValidator={this} channel="formTaoDon" endDate={ this.state.denNgay } onChange={ this.handleChangeDate.bind(this, 'tuNgay')} value={this.state.tuNgay} name='tuNgay' />
                  <DatePicker className="col-20" label="Đến ngày" bindValidator={this} channel="formTaoDon" startDate={ this.state.tuNgay } onChange={ this.handleChangeDate.bind(this, 'denNgay')} value={this.state.denNgay} name='denNgay' />
                  <DropDown className="col-25 mb18" label="Năm thanh tra/kiểm tra" options={this.props.namThanhTra} keyName="giaTri" valueName="ten" selectedValue={this.state.namThanhTra} onChange={this.onChange.bind(this, 'namThanhTra')} placeholder/>
                </div>
                <div className='col-16 mb0-18 search-thanh-tra'>
                  <button  className={classnames('btn-green', {'btn-loading-inline': this.state.loading})}>
                    <i className='tt-search'></i>Tìm kiếm
                  </button>
                </div>
              </div>
            </form>
            <div className='row'>
              <span className="line-border"></span>
            </div>
          </div>
          <DataTable
            header={ header.thanhTra.DSKHTTDPD }
            handleExport={this.handleExport.bind(this)}
            dataList={ this.state.data }
            exporttext="Xuất Excel"
            thanhTra
            hideButtonExport
            pageData={ this.state.pageData }
            parent={ this }
            search
            tableLoading={ this.state.tableLoading }>
            <RowItemDanhSachKeHoachThanhTraDaPheDuyet isTTTP={userInfo.donViId === this.state.thanhTraThanhPhoId}/>
          </DataTable>
        </div>
      </div>
    );
  }
}

DanhSachKeHoachThanhTraDaPheDuyet.defaultProps = {
  validators: {},
  goBack: false,
  namThanhTra: []
}

const mapStateToProps = function(state) {
  return {
    goBack: state.danhSachKHThanhTra.goBack,
    namThanhTra: state.danhSachKHThanhTra.namThanhTra
  }
}

export default connect(mapStateToProps)(DanhSachKeHoachThanhTraDaPheDuyet);



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/DanhSachKeHoachThanhTraDaPheDuyet.jsx